import { gate } from 'hub-http/gates';
export const AGENT_INBOX_GLOBAL_NAV = gate('AIRuntime::AgentInbox::GlobalNav');
export const CREATE_AGENT = gate('AIAgent:CreateAgent');
export const DRAFTS = gate('AIAgent:Drafts');
export const TOOLS_AUDIT = gate('AgentBuilder:ToolsAudit');
export const BREEZE_ENGINE_UI = gate('BreezeEngine:EngineUI');
export const CUSTOM_ASSISTANT_CREATION = gate('BreezeAssistant:CustomAssistant:Creation');